import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c2467df"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "priority_desc" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "w-100 py-4 mt-5 priority_desc" }
const _hoisted_4 = { class: "my-2 text-primary w-100 d-flex align-items-center justify-content-end" }
const _hoisted_5 = { class: "mb-0 d-none" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Needs", -1))
const _hoisted_7 = { class: "mb-4 text-primary" }
const _hoisted_8 = { class: "d-flex" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "details" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "" }, "Postpartum Hermorrhage"),
  /*#__PURE__*/_createElementVNode("small", null, [
    /*#__PURE__*/_createElementVNode("i", null, "Postpartum Hermorrhage")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "line_through" })
], -1))
const _hoisted_12 = { class: "text-primary mb-lg-5 mb-md-3 write_ups" }
const _hoisted_13 = { class: "mb-lg-5 mb-md-3" }
const _hoisted_14 = { type: "1" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Please note that when submitting your innovation proposal your preferred stage of proposal is Stage 4: Transition to scale process.", -1))
const _hoisted_16 = { class: "" }
const _hoisted_17 = { class: "my-5 d-flex justify-content-lg-end justify-content-center" }
const _hoisted_18 = { class: "container-fluid mb-lg-5 mb-md-3 px-3" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-center text-primary my-3" }, "Other Related Needs", -1))
const _hoisted_20 = {
  key: 0,
  class: "row"
}
const _hoisted_21 = {
  key: 1,
  class: "container-fluid mx-auto row justify-content-between"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Button = _resolveComponent("Button")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_LoginModal = _resolveComponent("LoginModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("section", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h6", _hoisted_5, [
              _createVNode(_component_router_link, { to: "/priority" }, {
                default: _withCtx(() => [
                  _createTextVNode("Innovation Priority Needs")
                ]),
                _: 1
              }),
              _createTextVNode(" / "),
              _hoisted_6
            ]),
            _createVNode(_component_Button, {
              label: "Back",
              icon: "pi pi-chevron-left",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
              class: "p-button-text p-button-raised",
              "aria-label": "Back"
            })
          ])
        ]),
        _createElementVNode("section", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("img", {
                src: require(`@/assets/png/needDesc.png`),
                alt: "logo.jpg",
                class: "img-fluid",
                width: "286",
                height: "161"
              }, null, 8, _hoisted_10)
            ]),
            _hoisted_11
          ])
        ]),
        _createElementVNode("section", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content, (data, index) => {
            return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(data), 1))
          }), 128)),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("h6", null, _toDisplayString(_ctx.innovationRequirement.title), 1),
            _createElementVNode("ol", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.innovationRequirement.content, (item, index) => {
                return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(item), 1))
              }), 128))
            ]),
            _createElementVNode("h6", null, _toDisplayString(_ctx.innovationRequirement2.title), 1),
            _createElementVNode("ol", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.innovationRequirement2.content, (item, index) => {
                return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(item), 1))
              }), 128))
            ])
          ]),
          _createElementVNode("p", null, [
            _hoisted_15,
            _createVNode(_component_router_link, { to: "/resource-library" }, {
              default: _withCtx(() => [
                _createTextVNode("Click here to view the Stages of Innovations")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("p", null, [
            _createElementVNode("strong", null, [
              _createTextVNode(" Innovation proposal must have passed the regulatory and ethical requirements\" For more information, visit the resource library "),
              _createVNode(_component_router_link, { to: "/resource-library" }, {
                default: _withCtx(() => [
                  _createTextVNode("Here")
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("section", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_BaseButton, {
              onButtonClick: _ctx.submit,
              customStyle: _ctx.btnStyleAlt
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Submit an innovation proposal")
              ]),
              _: 1
            }, 8, ["onButtonClick", "customStyle"])
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_18, [
        _hoisted_19,
        (_ctx.Datas?.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Datas.splice(0, 4), (data, i) => {
                return (_openBlock(), _createBlock(_component_Card, {
                  key: i,
                  body: data,
                  card: _ctx.cardDescriptionStyle
                }, null, 8, ["body", "card"]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_21, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
                return _createVNode(_component_Skeleton, {
                  key: i,
                  height: "15vh",
                  width: "24%",
                  class: "mb-3 col-lg-3 col-md-6 col-12"
                })
              }), 64))
            ]))
      ])
    ]),
    (_ctx.showModal)
      ? (_openBlock(), _createBlock(_component_LoginModal, {
          key: 0,
          onCloseClick: _ctx.close
        }, null, 8, ["onCloseClick"]))
      : _createCommentVNode("", true)
  ], 64))
}